import { utils } from '@hh/global.js'

/* mobile menu sideways panels */
const sidePanelOpen = document.querySelectorAll('[data-open-sidepanel]')
const sidePanelBody = document.querySelectorAll('[data-sidepanel]')
const sidePanelClose = document.querySelectorAll('[data-close-sidepanel]')

let lastFocusedElement

const toggleSidePanel = (index) => {
  const sidePanel = sidePanelBody[index]
  const isActive = !sidePanel?.hasAttribute('hidden')

  const togglePanelState = () => {
    if (!isActive) {
      lastFocusedElement = document.activeElement
      sidePanel.removeAttribute('hidden')
      utils.trapFocus(sidePanel)
    } else {
      sidePanel.setAttribute('hidden', 'true')
      if (lastFocusedElement) {
        lastFocusedElement.focus({ focusVisible: true })
      }
    }
  }

  togglePanelState()
}

const handleSidePanelToggle = (event) => {
  const target = event.target
  const trigger = target.closest('[data-open-sidepanel]')
  const triggerClose = target.closest('[data-close-sidepanel]')

  if (trigger) {
    const index = Array.from(sidePanelOpen).indexOf(trigger)
    toggleSidePanel(index)
  } else if (triggerClose) {
    const index = Array.from(sidePanelClose).indexOf(triggerClose)
    toggleSidePanel(index)
  }
}

/* mouse click and keyboard enter toggling */
document.addEventListener('click', handleSidePanelToggle)
